import { Typography, theme } from "antd";

type TableHeaderProps = {
  title: string;
  style?: React.CSSProperties;
};

export const TableHeader = ({ title, style }: TableHeaderProps) => {
  const { token } = theme.useToken();

  return (
    <Typography.Text
      ellipsis={{ tooltip: title }}
      strong
      style={{
        fontSize: token.fontSizeSM,
        letterSpacing: "0.05em",
        display: "block",
        minWidth: 0,
        textTransform: "uppercase",
        ...style,
      }}
    >
      {title}
    </Typography.Text>
  );
};
